/* eslint-disable no-console */
import { useState, useEffect } from 'react'
import { mySalesService } from '../Services/mySalesService'

export const useReferralLink = () => {
  const [referralLink, setReferralLink] = useState([])
  const [referralLinkLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchReferralLink = async () => {
      try {
        setIsLoading(true)
        const referralsData = await mySalesService.getReferralLink()
        setReferralLink(referralsData.data.referralLink)
        setError(null)
      } catch (err) {
        console.error('Error fetching referral Link:', err)
        setError(err.message || 'Error loading referral Link')
        setReferralLink({})
      } finally {
        setIsLoading(false)
      }
    }

    fetchReferralLink()
  }, [])

  return {
    referralLink,
    referralLinkLoading,
    error,
  }
}
